




































































import { Component, Vue } from "vue-property-decorator";
import { Button, Toast, Popup, Picker, Loading, Icon } from "vant";
import customField from "@/components/customField/index.vue";
import { login } from "@/utils/hybirdMethods";
import { isChinaPhone, isHKPhone } from "@/utils/verify";
import { getBrowser } from "@/utils/browser";
import * as Sentry from "@sentry/vue";

const browser = getBrowser();

@Component({
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Loading.name]: Loading,
    [Icon.name]: Icon,
    [customField.name]: customField,
    [Loading.name]: Loading,
  }
})
export default class Login extends Vue {
  userInfo = (this as any).$localstorage.get("h5userInfo") || {};
  //userInfo = sessionStorage.getItem("h5userinfo");
  form: any = {
    zone_code: this.userInfo.zone_code,//区号
    phone: this.userInfo.phone,
    type: 8,//8 h5 多账号专用
    code: "",

    key: "",
    login_type: 2 //1密码，2短信
  };
  displayPhone = this.getPhone(this.userInfo.phone);
  img = "";
  isSendVerCode = false;
  verCodeTime = 120;
  verCodeTimer: any = null;
  showZoneCodePicker = false;
  zoneCodeColumns:any = []
  isCaptchaLoading = true;
  isCaptchaError = false;
  loginLoading = false; // 登录loading

  get isDisabledSubmit() {
    let flag = false;
    for (const key in this.form) {
      if (!this.form[key] && key !== "key") {
        flag = true;
        break;
      }
    }
    return flag;
  }

  created() {
    this.zoneCodeColumns = [
      {
        text: this.$t('mki18n.t00005'),
        value: "852"
      },
      {
        text: this.$t('mki18n.t00006'),
        value: "86"
      }
    ];
	Toast.resetDefaultOptions();
    this.handleSendVerCode();
  }

  getPhone(phoneNumber) {
    // 判断输入的是否为手机号码
    if (!/^1[3456789]\d{9}$/.test(phoneNumber)) {
      return phoneNumber; // 如果不是手机号码，则直接返回原值
    }
    // 遮盖手机号的中间四位数字
    return phoneNumber.slice(0, 3) + "****" + phoneNumber.slice(7);
  }

  handleConfirmZoneCode(item) {
    this.form.zone_code = item.value;
    this.showZoneCodePicker = false;
  }

  verifyPhone() {
    if (this.form.zone_code == "86") {
      return isChinaPhone(this.form.phone);
    } else if (this.form.zone_code == "852") {
      return isHKPhone(this.form.phone);
    }
  }

  handleSendVerCode() {
    const { zone_code, phone, type } = this.form;
    if (!this.verifyPhone()) return this.$toast.fail("请输入正确的手机号");
    const params = {
      zone_code,
      phone,
      type
    };
    (this as any).$apis
      .h5SenMsg(params)
      .then(res => {
        
        Toast("发送短信成功");
        //以下是自动填充短信
        this.form.code = res.code;
        this.isSendVerCode = true;
        this.setIntervalSendCode();
      })
      .catch(e => {
        
        //Toast(e);
      });
  }

  setIntervalSendCode() {
    const now = new Date().getTime();
    const end = new Date(now + this.verCodeTime * 1000).getTime();
    this.verCodeTimer = setInterval(() => {
      this.verCodeTime = Math.ceil((end - new Date().getTime()) / 1000);
      if (this.verCodeTime <= 0) {
        clearInterval(this.verCodeTimer);
        this.verCodeTime = 120;
        this.isSendVerCode = false;
      }
    }, 1000);
  }

  handleSubmit() {
    if (!this.verifyPhone()) return this.$toast.fail("请输入正确的手机号");
    const { zone_code, phone, type, code } = this.form;

    const params = {
      zone_code,
      phone,
      type,
      code
    };

    (this as any).loginLoading = true; // 登录loading打开

    (this as any).$apis
      .h5msgCodeCheck(params)
      .then(res => {
        const { token, user_info } = res;

        try {
          // sentry监控，增加额外信息
          if(user_info.user_id){
            (this as any).addInfoToSentry({
              user_id: user_info.user_id
            })
          }
        } catch (err){
          
        }

        (this as any).$localstorage.set("h5userInfo", user_info);
        localStorage.setItem("token", token);
        (this as any).$apis
          .accountList()
          .then(res => {
            (this as any).loginLoading = false; // 登录loading关闭

            let isJump = false;
            if (res.data != null) {
              for (let i = 0; i < res.data.length; i++) {
                //登录之后，请求多账号列表，如果启动某个账号是is_new或者账号断连了，都跳转到账号列表，反之去首页
                if (res.data[i].is_new == 1 || res.data[i].status == 0) {
                  isJump = true;
                  break;
                }
              }
            }
			this.$router.replace("/h5-page-account");
            // if (isJump) {
            //   this.$router.replace("/h5-page-account");
            // } else {
            //   this.$router.replace("/h5-page-transaction-home");
            // }
            
          })
          .catch(e => {

            (this as any).loginLoading = false; // 登录loading关闭

            
          });


      })
      .catch(e => {

        (this as any).loginLoading = false; // 登录loading关闭

        
      });
  }

  /**
   * @Description 增加额外信息到Sentry
   * @date 2024/2/1
   * @param {Object} infoObj 额外信息
   * @return {void}
   */
  addInfoToSentry(infoObj = {}) {
    Sentry.configureScope(scope => {
      scope.setUser(infoObj);
    });
  }
}
